export default __webpack_public_path__ + "static/media/08_DAIF_WHY_DELL_04_01.f580f1dc.mp4";